import {
  getStaticPropsGenerator,
  getStaticPathsGenerator,
} from '@cinch-nx/landing-feature-policy-page'

import { traceFunction } from '@core/datadog-server'

const path = 'policies/modern-slavery-statement/statements'

export const getStaticProps = traceFunction(
  'modernSlaveryStatement getStaticProps',
  getStaticPropsGenerator(path),
)
export const getStaticPaths = traceFunction(
  'modernSlaveryStatement getStaticPaths',
  getStaticPathsGenerator(`policies/${path}`),
)

export { PolicyPageFeature as default } from '@cinch-nx/landing-feature-policy-page'
